import { ProfileView } from '../app/components/ProfileView';

/**
 * ProfilePage
 *
 * Simple wrapper for profile view.
 * Future: Can add query parameters for edit mode, vehicles sheet, etc.
 * Example: ?edit=true, ?vehicles=true
 */
export function ProfilePage() {
  return <ProfileView />;
}
